import type { UIFacet } from 'src/components/types/UIFacet';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

interface AdaptFacetToUIFacetOptions {
  /** Pill row only: keep an all-zero promoted facet, to disable it rather than drop it. */
  keepEmptyPromotedFacets?: boolean;
}

export const adaptFacetToUIFacet = (
  facets: Facet[],
  taxonomyAttributeAliases: TaxonomyAttribute[] = [],
  { keepEmptyPromotedFacets = false }: AdaptFacetToUIFacetOptions = {},
): UIFacet[] => {
  const facetsWithProducts = facets.filter(
    (facet) =>
      !taxonomyAttributeAliases.includes(facet.alias) &&
      ((keepEmptyPromotedFacets && facet.promoted === true) ||
        facet.options.some((option) => option.count !== 0)),
  );

  return facetsWithProducts.map((facet) => {
    return {
      alias: facet.alias,
      key: facet.key,
      options: facet.options.map((option) => {
        // `crawlable` is populated later by `adaptStoreToUIFacetHrefs`, once each
        // option's toggle href is known and can be matched against the map.
        return {
          active: option.active,
          count: option.count,
          title: option.title,
          value: option.value,
          custom: option.custom,
        };
      }),
      title: facet.title || '',
      type: facet.type,
      ...(facet.singleOptionOnly === true ? { singleOptionOnly: true } : {}),
      ...(facet.static === true ? { static: true } : {}),
      ...(facet.promoted === true ? { promoted: true } : {}),
    };
  });
};
